import Axios from "axios";
import { ApiBaseUrl, Branch } from "../config/config";
import { ApiResultModel } from "../models/common.model";
import { branchResponse, StoreBySupplier } from "../models/branch.model";

export const GetBranchBySupplier = (): Promise<branchResponse[]> => {
  return Axios.post<ApiResultModel<branchResponse[]>>(
    ApiBaseUrl + Branch + "/GetBranchBySupplier"
  ).then((result) => {
    return result.data.data;
  });
};

export const GetStoreBySupplier = (): Promise<StoreBySupplier[]> => {
  return Axios.post<ApiResultModel<StoreBySupplier[]>>(
    ApiBaseUrl + Branch + "/GetStoreBySupplier"
  ).then((result) => {
    return result.data.data;
  });
};
